import React from 'react';
import { Grid, Box, Typography, Theme, SxProps } from '@mui/material';

type WarningMessageProps = {
  warningMessage: string;
  sx?: SxProps<Theme>;
  boxSx?: SxProps<Theme>;
};
const WarningMessage = ({ warningMessage, sx, boxSx }: WarningMessageProps) => {
  return (
    <Grid xs={12} sx={{ ml: 2, mt: 1, ...sx }}>
      <Box
        sx={{
          paddingLeft: '1rem',
          borderLeft: '4px solid #FFCC00',
          marginTop: '.5rem',
          ...boxSx,
        }}
      >
        <Typography variant="caption" fontSize="13px">
          {warningMessage}
        </Typography>
      </Box>
    </Grid>
  );
};

export default WarningMessage;
